import moment from 'moment';
import { calcScheduleCampaignCalendarDateRange } from '../../../../models/UiUtils';

export const NUM_WEEKS_SHOWN_IN_CAL: 4 | 6 = 6;

export type DateRange = {
	startDate: Date;
	endDate: Date;
};

export type State = {
	dateRange: DateRange;
	/** The calendar's visible month. Updated by jumps and by arrow navigation (via monthNavigated). */
	month: Date;
	selectedDate: Date;
	sendNow: boolean;
};

export type Actions =
	| {
			type: 'setDateRange';
			payload: DateRange;
	  }
	| {
			type: 'calendarDaySelected';
			payload: Date;
	  }
	| {
			type: 'scheduleHourChange';
			payload: number;
	  }
	| {
			type: 'setSendNow';
			payload: boolean;
	  }
	| {
			type: 'jumpToDateApplied';
			payload: Date;
	  }
	| {
			type: 'monthNavigated';
			payload: Date;
	  };

export const reducer = (state: State, action: Actions): State => {
	switch (action.type) {
		case 'setDateRange': {
			return {
				...state,
				dateRange: action.payload,
			};
		}
		case 'calendarDaySelected': {
			const newDate = new Date(action.payload);
			newDate.setHours(state.selectedDate.getHours(), state.selectedDate.getMinutes(), 0);
			return {
				...state,
				selectedDate: newDate,
				sendNow: moment(newDate).isSame(moment(), 'day'), // If the new selectedDate is today, set sendNow to true
			};
		}
		case 'scheduleHourChange': {
			const newDate = new Date(state.selectedDate);
			newDate.setHours(Math.floor(action.payload / 60), action.payload % 60, 0);
			return {
				...state,
				selectedDate: newDate,
			};
		}
		case 'setSendNow': {
			return {
				...state,
				sendNow: action.payload,
			};
		}
		case 'jumpToDateApplied': {
			const newDate = new Date(action.payload);
			newDate.setHours(state.selectedDate.getHours(), state.selectedDate.getMinutes(), 0);
			return {
				dateRange: calcScheduleCampaignCalendarDateRange({
					numWeeks: NUM_WEEKS_SHOWN_IN_CAL,
					selectedDate: newDate,
				}),
				// Fresh Date reference so react-day-picker-old's month-prop sync sees a change
				month: new Date(action.payload),
				selectedDate: newDate,
				sendNow: moment(newDate).isSame(moment(), 'day'),
			};
		}
		case 'monthNavigated': {
			return {
				...state,
				month: action.payload,
			};
		}
		default: {
			throw new Error('Invalid action type');
		}
	}
};
